'use client';

import { H3 } from 'components/ring-air/styleConstants';
import { CustomImage } from '..';
import { useCartStore, useShallow } from 'components/shared/Cart';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { Container, Content } from './LayoutComponents';
import styles from './SensorFeatures.module.css';

export const SensorFeatures = ({ className }: { className?: string }) => {
  const { store } = useCartStore(useShallow((s) => ({ store: s.store })));
  return (
    <Container fill="white">
      <Content>
        <div className={`${styles.root}${className ? ` ${className}` : ''}`}>
          <div className={styles.content}>
            <div className={`${styles.description} ${styles['description-1']}`}>
              <H3>
                A sensor to track{' '}
                <span className={styles.highlight}>
                  real&#x2011;time glucose levels
                </span>
              </H3>
              <p>
                The {store === ShopifyStore.US ? 'M2 Live' : 'M1 Live'} is
                developed in collaboration with top metabolic health experts
                and athletes to accurately measure your metabolic performance
                using glucose as a biomarker.
              </p>
            </div>
            <CustomImage
              src="web_v2/home/blogs/1.webp"
              width="6400"
              height="6568"
              alt="something"
              className="metabolism"
            />
            {/* <CustomImage /> */}
          </div>
          <div className={`${styles.content} ${styles['content-reverse']}`}>
            <CustomImage
              src="web_v2/m1/metabolism-screen-mockup-updated.png"
              width="1924"
              height="3156"
              alt="metabolism-screen-mockup"
              className="screen-mockup"
            />
            <div className={`${styles.description} ${styles['description-2']}`}>
              <H3>
                An app to <span className={styles.highlight}>connect the dots</span>
              </H3>
              <p>
                Track your glucose trends in real-time with the app. Discover
                the impact of food and exercise on your glucose levels with
                real-time actionable nudges that help you improve your
                metabolic health.
              </p>
            </div>
          </div>
        </div>
      </Content>
    </Container>
  );
};
